module.exports = __webpack_public_path__ + "img/31.2e0e2620.jpg";